import CostColumns from "./lib/CostColumns";
import { Operation, Costs } from "./lib/types";
import RowLayout from "./lib/RowLayout";
import useOperationListContext from "./lib/useOperationListContext";

export default function FooterRow({
  operations,
  left,
}: {
  operations: Operation[];
  left: React.ReactNode;
}) {
  const { quantities } = useOperationListContext();
  return (
    <RowLayout
      left={<Left />}
      right={<Right />}
      className="sticky bottom-0"
      showScrollbar
    />
  );

  function Left() {
    return (
      <div className="w-full flex items-center justify-between pl-px pr-2">
        {left}
        <div className="flex flex-col text-xs items-end">
          <div className="font-bold">Total</div>
          <div className="text-gray-500">Unit</div>
        </div>
      </div>
    );
  }

  function Right() {
    return (
      <div className="flex flex-col justify-end">
        <CostColumns costsOverride={sumCosts(quantities, operations)} />
      </div>
    );
  }
}

function sumCosts(quantities: number[], operations: Operation[]): Costs {
  const sum: Costs = {};
  operations.forEach(({ costs }) => {
    if (costs) {
      quantities.forEach((q, index) => {
        // this relies on the order of the keys; backend does use order_by currently
        const subPartCostKeys = Object.keys(costs);
        const cost = costs[q] || costs[subPartCostKeys[index]];

        const sumTotal = sum[q]?.total?.value
          ? Number(sum[q]?.total?.value)
          : 0;
        const opTotal = cost?.total?.value ? Number(cost.total.value) : 0;

        sum[q] = {
          total: { value: (sumTotal + opTotal).toFixed(2), unit: "USD" },
        };
      });
    }
  });
  return sum;
}
